import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';

export const theme = extendTheme({

  styles: {

    global: {

      body: {
        bg: colors.background,
        color: colors.text
      }
    }
  }
});